import React from "react";
import { Redirect, Route } from "react-router-dom/cjs/react-router-dom.min";
import { getToken, getRole } from "../service/AuthService";

const PrivateRoute = ({ component: Component, allowedRoles, ...rest }) => {
  return (
      <Route
  {...rest}
  render={props => {
    const token = getToken();
    const role  = getRole();

    if (!token) return <Redirect to={{ pathname: "/Login" }} />;
    if (allowedRoles && !allowedRoles.includes(role)) return <Redirect to={{ pathname: "/" }} />;
    return <Component {...props} />;
  }}
  />
  );
};

export default PrivateRoute;